export { default } from '@/features/locationsStatistics/api';
